// import React, { Component } from "react";
// import { connect } from "react-redux";
// import profile from "../../assets/images/profile.png";
import setting from "../../assets/images/setting.png";
// import arrow from "../../assets/images/arrow.png";
import { Image } from "react-bootstrap";
// import logout from "../../assets/images/logout.png";
// import ChangePasswordModal from "./_utils/ChangePasswordModal";
// import { withRouter } from "../../utils/hoc/withRouter";


import React from "react";
import PropTypes from "prop-types";
import {
  BaseReactComponent,
  CustomTextControl,
  Form,
  FormElement,
  FormSubmitButton,
  FormValidator,
} from "../../utils/form";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { changePasswordApi } from './Api';
import { withRouter } from "../../utils/hoc/withRouter";

// class Profile extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       forgotPassword: false,
//       finAdmin: JSON.parse(localStorage.getItem("finAdmin")),
//     };
//   }

//   componentDidMount() {

//   }
//   openCloseForgotPasswordModal = () => {
//     this.setState({
//       forgotPassword: !this.state.forgotPassword,
//     });
//   };
//   render() {
//     return (
//       <section className="profile-section">
//         {this.state.forgotPassword && (
//           <ChangePasswordModal
//             show={this.state.forgotPassword}
//             handleClose={this.openCloseForgotPasswordModal}
//           />
//         )}
//         <div className="profile-div">
//           <div className="profile-content">
//             <Image src={profile} className="profile-img" />
//             <h3 className="inter-semibold f-s-16 lh-24 black">{this.state.finAdmin?.user.name}</h3>
//             <h3 className="inter-semibold f-s-16 lh-24 black">{this.state.finAdmin?.user.emailAddress}</h3>
//           </div>
//           <div className="profile-setting-wrapper">
//             <div className="setting">
//               <div className="setting-content">
//                 <Image src={setting} className="" />
//                 <div>
//                   <h4 className="inter-semibold f-s-18 lh-21 black">Setting</h4>
//                   <p onClick={this.openCloseForgotPasswordModal} className="inter-regular f-s-14 grey-757 lh-19">
//                     Change Password
//                   </p>
//                 </div>
//               </div>
//               <Image src={arrow} className="" />
//             </div>
//             <hr />
//             <div className="setting">
//               <div className="setting-content">
//                 <Image src={logout} className="" />

//                 <div onClick={() => (window.location.href = "/")}>
//                   <h4 className="inter-semibold f-s-18 lh-21 black">Logout</h4>
//                   <p className="inter-regular f-s-14 grey-757 lh-19">
//                     Logout from TheFinpedia
//                   </p>
//                 </div>
//               </div>
//               <Image src={arrow} className="" />
//             </div>
//           </div>
//         </div>
//       </section>
//     );
//   }
// }

// const mapStateToProps = (state) => ({
//   profileState: state.ProfileState,
// });
// const mapDispatchToProps = {
//   // getPosts: fetchPosts
// };
// Profile.propTypes = {
//   // getPosts: PropTypes.func
// };

// export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Profile));




class ChangePasswordModal extends BaseReactComponent {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "",
      currentPassword: "",
      newPassword: "",
      verifyPassword: "",
      inProgress: false,
    };
  }
  componentDidMount() { }

  onSubmit = async () => {
    const { currentPassword, newPassword, verifyPassword } = this.state;
    if (newPassword === verifyPassword) {
      const data = {
        "data": {
          "currentPassword": currentPassword,
          "newPassword": newPassword
        }
      }
      changePasswordApi(data, this.props.handleClose);

    } else {
      toast.error('Password not matched.')
    }
  };
  render() {
    return (
      <div className="change-password-page ">

        <div className="setting-content d-flex gap-8 align-items-center mb-5">
          <Image src={setting} className="" />
          <div>
            <h4 className="inter-semibold f-s-28 lh-21 black">Change Password</h4>
          </div>
        </div>
        <Form onValidSubmit={this.onSubmit}>
          <FormElement
            valueLink={this.linkState(this, "currentPassword")}
            label="Current Password"
            required
            validations={[
              {
                validate: FormValidator.isRequired,
                message: "Password cannot be empty",
              },
            ]}
            control={{
              type: CustomTextControl,
              settings: {
                type: "password",
                placeholder: "Enter Current Password",
              },
            }}
          />
          <FormElement
            valueLink={this.linkState(this, "newPassword")}
            label="New Password"
            required
            validations={[
              {
                validate: FormValidator.isRequired,
                message: "Password cannot be empty",
              },
            ]}
            control={{
              type: CustomTextControl,
              settings: {
                type: "password",
                placeholder: "Enter New Password",
              },
            }}
          />
          <FormElement
            valueLink={this.linkState(this, "verifyPassword")}
            label="Verify Password"
            required
            validations={[
              {
                validate: FormValidator.isRequired,
                message: "Password cannot be empty",
              },
            ]}
            control={{
              type: CustomTextControl,
              settings: {
                type: "password",
                placeholder: "Verify the Password",
              },
            }}
          />

          {this.state.errorMessage && (
            <p className="error">{this.state.errorMessage}</p>
          )}
          <div className="submit-wrapper gap-20">
            <Button onClick={()=>this.props.navigate(-1)} className="secondary-btn">Cancel</Button>
            <FormSubmitButton customClass="primary-btn">
              Submit
            </FormSubmitButton>
          </div>
        </Form>
      </div>
    );
  }
}

ChangePasswordModal.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};
export default withRouter(ChangePasswordModal);

